import {
	GROUPS_FETCH_REQUEST,
	GROUPS_FETCH_FAILURE,
	GROUPS_FETCH_SUCCESS,
	GROUP_FETCH_REQUEST,
	GROUP_FETCH_FAILURE,
	GROUP_FETCH_SUCCESS,
	GROUP_UPDATE_REQUEST,
	GROUP_UPDATE_FAILURE,
	GROUP_UPDATE_SUCCESS,
	GROUP_CREATE_REQUEST,
	GROUP_CREATE_FAILURE,
	GROUP_CREATE_SUCCESS,
	GROUP_SET,
	GROUP_RESET_MESSAGE,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function groups(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case GROUP_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case GROUP_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case GROUPS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case GROUPS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case GROUPS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case GROUP_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case GROUP_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case GROUP_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.group),
			};

		case GROUP_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case GROUP_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case GROUP_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case GROUP_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case GROUP_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case GROUP_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/groups.js